module.exports = __webpack_public_path__ + "static/media/linkedinWhite.16feb175.png";